(() => {
  const initProductForm = () => {
    const form = document.querySelector("[data-product-form]");
    if (!form) return;

    const variantsEl = form.querySelector("[data-product-variants]");
    const stringsEl = form.querySelector("[data-product-strings]");
    if (!variantsEl || !stringsEl) return;

    let variants = [];
    let strings = {};
    try {
      variants = JSON.parse(variantsEl.textContent);
      strings = JSON.parse(stringsEl.textContent);
    } catch (_) {
      return;
    }

    const idInput = form.querySelector("[data-product-variant-id]");
    const submitBtn = form.querySelector("[data-product-submit]");
    const priceEl = document.querySelector("[data-product-price]");
    const labelEl = document.querySelector("[data-product-availability-label]");
    const mainImage = document.querySelector("[data-product-main-image]");
    const variantsUi = form.querySelector("[data-product-variants-ui]");
    const atelierNote = form.querySelector("[data-atelier-note]");
    const optionInputs = [...form.querySelectorAll("input[data-option-position]")];
    const modeInputs = [...form.querySelectorAll("[data-purchase-mode]")];

    const getMode = () =>
      modeInputs.find((input) => input.checked)?.dataset.purchaseMode || "ready";

    const getSelectedOptions = () => {
      const selected = [null, null, null];
      optionInputs.forEach((input) => {
        if (!input.checked) return;
        const index = Number(input.dataset.optionPosition) - 1;
        selected[index] = input.value;
      });
      return selected;
    };

    const findVariant = (options) =>
      variants.find(
        (variant) =>
          variant.option1 === options[0] &&
          variant.option2 === options[1] &&
          variant.option3 === options[2]
      );

    const findAtelierVariant = () => {
      const named = variants.find((variant) => {
        const title = String(variant.title || "").toLowerCase();
        return (
          title.includes("atelier") ||
          title.includes("custom") ||
          title.includes("made to order") ||
          title.includes("по поръчка") ||
          title.includes("ателие")
        );
      });
      if (named && (named.purchase_state === "in_stock" || named.purchase_state === "made_to_order")) {
        return named;
      }
      return (
        variants.find((variant) => variant.purchase_state === "in_stock" || variant.purchase_state === "made_to_order") ||
        variants[0]
      );
    };

    const syncOptionAvailability = () => {
      if (!variantsUi || getMode() === "atelier") return;
      const selected = getSelectedOptions();
      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const trial = [...selected];
        trial[position] = input.value;
        const match = variants.find((variant) => {
          const opts = [variant.option1, variant.option2, variant.option3];
          return trial.every((value, index) => value == null || opts[index] === value);
        });
        const purchasable =
          match &&
          (match.purchase_state === "in_stock" || match.purchase_state === "made_to_order");
        input.disabled = !match;
        input.closest(".product-option__value")?.classList.toggle("is-unavailable", !purchasable);
      });
    };

    const updateUI = () => {
      const mode = getMode();
      const isAtelier = mode === "atelier";

      if (variantsUi) {
        variantsUi.hidden = isAtelier;
        optionInputs.forEach((input) => {
          input.required = !isAtelier && !productHasOnlyDefault();
          if (isAtelier) input.required = false;
        });
      }
      if (atelierNote) atelierNote.hidden = !isAtelier;

      let variant;
      if (isAtelier) {
        variant = findAtelierVariant();
      } else if (optionInputs.length) {
        variant = findVariant(getSelectedOptions());
      } else {
        variant = variants[0];
      }

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = strings.unavailable || strings.sold_out;
        }
        if (labelEl) labelEl.textContent = strings.unavailable || strings.sold_out;
        return;
      }

      if (idInput) idInput.value = String(variant.id);
      if (priceEl) priceEl.textContent = variant.price_formatted;

      const purchasable =
        variant.purchase_state === "in_stock" || variant.purchase_state === "made_to_order";

      if (labelEl) {
        if (variant.purchase_state === "in_stock") labelEl.textContent = strings.one_piece;
        else if (variant.purchase_state === "made_to_order") labelEl.textContent = strings.made_to_order;
        else labelEl.textContent = strings.sold_out;
        labelEl.hidden = !labelEl.textContent;
      }

      if (submitBtn) {
        submitBtn.disabled = !purchasable;
        submitBtn.textContent = purchasable ? strings.add_to_cart : strings.sold_out;
      }

      if (mainImage && variant.image) {
        mainImage.src = variant.image;
      }

      syncOptionAvailability();
    };

    const productHasOnlyDefault = () => optionInputs.length === 0;

    modeInputs.forEach((input) => input.addEventListener("change", updateUI));
    optionInputs.forEach((input) => input.addEventListener("change", updateUI));
    updateUI();
  };

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const reveals = document.querySelectorAll(".reveal");
  if (reveals.length && !reduceMotion && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-visible"));
  }

  const drawer = document.getElementById("mobile-nav");
  const openBtn = document.querySelector("[data-menu-open]");
  const closeBtn = document.querySelector("[data-menu-close]");
  openBtn?.addEventListener("click", () => drawer?.classList.add("is-open"));
  closeBtn?.addEventListener("click", () => drawer?.classList.remove("is-open"));
  drawer?.querySelectorAll("a").forEach((a) =>
    a.addEventListener("click", () => drawer.classList.remove("is-open"))
  );

  // Cart count in nav (preview)
  try {
    const count = JSON.parse(localStorage.getItem("af-cart") || "[]").length;
    document.querySelectorAll('[data-i18n="nav.cart"]').forEach((el) => {
      el.dataset.cartCount = String(count);
    });
  } catch (_) {}

  initProductForm();

  const initProductTabs = () => {
    document.querySelectorAll("[data-product-tabs]").forEach((root) => {
      const tabs = [...root.querySelectorAll("[data-product-tab]")];
      const panels = [...root.querySelectorAll("[data-product-panel]")];
      if (!tabs.length || !panels.length) return;

      const activate = (id) => {
        tabs.forEach((tab) => {
          const selected = tab.dataset.productTab === id;
          tab.classList.toggle("is-active", selected);
          tab.setAttribute("aria-selected", selected ? "true" : "false");
          tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.productPanel === id;
          panel.classList.toggle("is-active", selected);
          panel.hidden = !selected;
        });
      };

      tabs.forEach((tab, index) => {
        tab.tabIndex = tab.classList.contains("is-active") ? 0 : -1;
        tab.addEventListener("click", () => activate(tab.dataset.productTab));
        tab.addEventListener("keydown", (event) => {
          const key = event.key;
          if (key !== "ArrowRight" && key !== "ArrowLeft" && key !== "Home" && key !== "End") return;
          event.preventDefault();
          let nextIndex = index;
          if (key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
          if (key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (key === "Home") nextIndex = 0;
          if (key === "End") nextIndex = tabs.length - 1;
          tabs[nextIndex].focus();
          activate(tabs[nextIndex].dataset.productTab);
        });
      });
    });
  };

  initProductTabs();

  const dict = window.AF_I18N || null;
  if (!dict) return;

  const applyLang = (lang) => {
    const strings = dict[lang] || dict.en;
    document.documentElement.lang = lang;
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.getAttribute("data-i18n");
      if (!strings[key]) return;
      let text = strings[key];
      if (key === "nav.cart" && el.dataset.cartCount) {
        text = text.replace(/\(\d+\)/, `(${el.dataset.cartCount})`);
      }
      el.textContent = text;
    });
    document.querySelectorAll("[data-i18n-placeholder]").forEach((el) => {
      const key = el.getAttribute("data-i18n-placeholder");
      if (strings[key]) el.setAttribute("placeholder", strings[key]);
    });
    document.querySelectorAll(".lang-switch button").forEach((btn) => {
      btn.setAttribute("aria-current", btn.dataset.lang === lang ? "true" : "false");
    });
    try {
      localStorage.setItem("af-lang", lang);
    } catch (_) {}
  };

  document.querySelectorAll(".lang-switch button").forEach((btn) => {
    btn.addEventListener("click", () => {
      applyLang(btn.dataset.lang);
      if (typeof window.AF_RENDER_LEGAL === "function") {
        window.AF_RENDER_LEGAL(btn.dataset.lang);
      }
    });
  });

  let initial = "en";
  try {
    initial = localStorage.getItem("af-lang") || initial;
  } catch (_) {}
  applyLang(initial);
})();
